import React from 'react';
import { Alert, AlertTitle, Collapse, Typography } from '@mui/material';

interface SubmissionAlertProps {
	showCondition: boolean;
	success: boolean;
	onClose: () => void;
	messages: string[];
}

const SubmissionAlert: React.FC<SubmissionAlertProps> = ({ showCondition, success, onClose, messages }) => {
	return (
		<Collapse in={showCondition}>
			<Alert severity={success ? 'success' : 'error'} onClose={onClose}>
				<AlertTitle>{messages[0]}</AlertTitle>
				{messages.length > 1 &&
					messages.slice(1).map((msg) => {
						return <Typography key={`submission-alert-msg-${msg}`}>{msg}</Typography>;
					})}
			</Alert>
		</Collapse>
	);
};

export default SubmissionAlert;
